<template>
  <div>
    <!--begin::Dashboard-->
    <div class="row" style="min-height: 20rem">
      <div class="col-xxl-4 px-md-3 px-sm-0">
        <MixedWidget1 :transaction="true"></MixedWidget1>
      </div>

      <div class="col-xxl-8 px-md-3 px-sm-0" style="max-height: 200px">
        <ListWidget9></ListWidget9>
      </div>

      <div class="col-xxl-12 px-md-3 px-sm-0" :style="{'margin-top':heightBAnner+'rem'}">
        <DashboardBaner></DashboardBaner>
      </div>

      <div class="col-xxl-12 px-md-1" :style="{'margin-top':height+'rem'}">
        <newsKab></newsKab>
      </div>

    </div>
    <!--end::Dashboard-->
  </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import AdvancedTableWidget2 from "@/view/content/widgets/advance-table/Widget2.vue";
import MixedWidget1 from "@/view/content/widgets/mixed/Widget1.vue";
import ListWidget1 from "@/view/content/widgets/list/Widget1.vue";
import ListWidget9 from "@/view/content/widgets/list/Widget9.vue";
import ListWidget11 from "@/view/content/widgets/list/Widget11.vue";
import ListWidget12 from "@/view/content/widgets/list/Widget12.vue";
import ListWidget13 from "@/view/content/widgets/list/Widget13.vue";
import ListWidget14 from "@/view/content/widgets/list/Widget14.vue";
import ListWidget15 from "@/view/content/widgets/list/Widget15.vue";
import DashboardBaner from "@/view/pages/uiBeautifier/DashboardBaner";
import Notes from "@/view/pages/uiBeautifier/Notes";
import RailNavigation from "@/view/pages/uiBeautifier/RailNavigation";
import NewsKab from "@/view/pages/uiBeautifier/newsKAB";
import fourtables from "@/view/pages/fourtables";

export default {
  name: "dashboard",
  components: {
    RailNavigation,
    Notes,
    DashboardBaner,
    fourtables,
    AdvancedTableWidget2,
    MixedWidget1,
    ListWidget1,
    ListWidget9,
    ListWidget11,
    ListWidget12,
    ListWidget13,
    ListWidget14,
    ListWidget15,
    NewsKab
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{title: "Dashboard"}]);
  },
  methods: {
    setActiveTab1(event) {
      this.tabIndex = this.setActiveTab(event);
    },
    setActiveTab2(event) {
      this.tabIndex2 = this.setActiveTab(event);
    },
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set current active tab
      event.target.classList.add("active");

      // set clicked tab index to bootstrap tab
      return parseInt(event.target.getAttribute("data-tab"));
    }
  },
  computed: {
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 1
        case 'sm':
          return 400
        case 'md':
          return 500
        case 'lg':
          return 0
        case 'xl':
          return 0
      }
    },
    heightBAnner() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 102
        case 'sm':
          return 400
        case 'md':
          return 0
        case 'lg':
          return 0
        case 'xl':
          return 0
      }
    },
  },
};
</script>
